module.exports = {
	//后台请求地址配置 //南栀，瓦兰 
	// baseUrl: process.env.NODE_ENV === 'development' ? 'http://192.168.3.120:10004' : '/prod-api'
	baseUrl: process.env.NODE_ENV === 'development' ? 'https://back.walands.com' : 'https://back.walands.com'
	// baseUrl: process.env.NODE_ENV === 'development' ? 'http://192.168.3.16:10005' : 'https://back.walands.com'
}
